__turbopack_context__.v({
  "QRCodeButton": "AppInstallModal-module-scss-module__xC2C0W__QRCodeButton",
  "QRCodeContainer": "AppInstallModal-module-scss-module__xC2C0W__QRCodeContainer",
  "QRCodeContent": "AppInstallModal-module-scss-module__xC2C0W__QRCodeContent",
  "QRCodeImage": "AppInstallModal-module-scss-module__xC2C0W__QRCodeImage",
  "confirmButton": "AppInstallModal-module-scss-module__xC2C0W__confirmButton",
  "confirmButtonWrapper": "AppInstallModal-module-scss-module__xC2C0W__confirmButtonWrapper",
  "content": "AppInstallModal-module-scss-module__xC2C0W__content",
  "contentInner": "AppInstallModal-module-scss-module__xC2C0W__contentInner",
  "contentShow": "AppInstallModal-module-scss-module__xC2C0W__contentShow",
  "overlay": "AppInstallModal-module-scss-module__xC2C0W__overlay",
  "overlayShow": "AppInstallModal-module-scss-module__xC2C0W__overlayShow",
  "wrap": "AppInstallModal-module-scss-module__xC2C0W__wrap",
});
